"use client";
import { createContext, useContext } from 'react';

const QuarksContext = createContext({});
function useQuarksContext() {
    return useContext(QuarksContext);
}

export { QuarksContext, useQuarksContext };
//# sourceMappingURL=QuarksContext.js.map
